module.exports = __webpack_public_path__ + "img/triangle-alert.5f241b73.svg";